import React, { useEffect, useRef, useState } from 'react';
import {
   Backdrop,
   Box,
   Button,
   Checkbox,
   Chip,
   Dialog,
   DialogActions,
   DialogTitle,
   Divider,
   FormControlLabel,
   Grid,
   IconButton,
   InputAdornment,
   Paper,
   Radio,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import {
   AlertLabel,
   Input,
   TextFieldCustom,
} from '../../../assets/styled/Element';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { GoogleAddressLookup } from 'react-rainbow-components';
import { endOfDay, format } from 'date-fns';
import { enUS, th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker, useDateInput } from 'react-nice-dates';
import { TitleLabel } from '../../../components/Element/LabelInputForm';
import SearchEmployee from '../../Search/SearchEmployee';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import {
   isObject,
   reverseFormatNumber,
} from '../../../configs/helpers/utility';
import SearchDivision from '../../Search/SearchDivision';
import dayjs from 'dayjs';
import { GSBtoWording } from "../../../configs/helpers/GSBtoWording"
 
const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '55%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));

const Edit = (props) => {
   const classes = useStyles();
   const [data, setData] = useState(props.data);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         activityCode: data.activityCode,
         activityNameTh: data.activityNameTh,
         activityNameEn: data.activityNameEn,
         // ownerDetail: data.creatorEmployeeName,
         rule: `${data.ruleCode} : ${data.ruleName}`,
         // employee: data.affordableEmployeeNameTh,
         startDate: new Date(data.startDate),
         endDate: new Date(data.endDate),
         isCanJoinOneMoreTime: data.allowMultipleScan,
         location: data.venue,
         activityPoint: new Intl.NumberFormat().format(data.remainingPoint),
         gPointPerPerson: new Intl.NumberFormat().format(data.gPointPerPerson),
         sPointPerPerson: new Intl.NumberFormat().format(data.sPointPerPerson),
         bPointPerPerson: new Intl.NumberFormat().format(data.bPointPerPerson),
         // latitude: data.latitude,
         // longtitude: data.longtitude,
         isUseLocation: data.isUseLocation,
      },
   });
   const { fields, append, remove } = useFieldArray({
      control,
      name: 'employee',
   });
   const [showAdvance, setShowAdvance] = useState(false);
   const { toggle } = watch();
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   const selectLocation = watch('location');
   const selectCheckbox = watch('isCanJoinOneMoreTime');
   const [selectRadio, setSelectRadio] = useState({
      whiteList: data.whitelistDivisions ? 'b' : 'a',
      blackList: data.blacklistDivisions ? 'b' : 'a',
   });
   const selectLocationCheckbox = watch('isUseLocation');
   const [popup, setPopup] = useState(false);
   const [dataModel, setDataModel] = useState({
      orgOwner: [],
      affordableOrgEmployee: [],
      whitelistDivisions: [],
      blacklistDivisions: [],
      whitelistEmployees: [],
      blacklistEmployees: [],
   });
   const [editAdvance, setEditAdvance] = useState(true);
   useEffect(() => {
      if (
         data.whitelistDivisions ||
         data.blacklistDivisions ||
         data.whitelistEmployees ||
         data.blacklistEmployees ||
         data.affordableEmployeeNameTh
      ) {
         if (
            data.whitelistDivisions ||
            data.blacklistDivisions ||
            data.whitelistEmployees ||
            data.blacklistEmployees
         ) {
            setShowAdvance(true);
            setEditAdvance(true);
         }
         setDataModel({
            orgOwner: [
               {
                  value: data.data.activityOwnerOrgEmployeeId,
                  label: `${data.data.activityOwnerOrgEmployeeId} ${data.data.activityOwnerNameTh}`,
               },
            ],
            affordableOrgEmployee: data.data.affordableEmployeeNameTh
               ? data.data.affordableEmployeeNameTh.map((value) => ({
                    label: `${value.employeeOrgId} : ${value.employeeNameTh}`,
                    value: value.employeeOrgId,
                 }))
               : [],
            whitelistDivisions: data.data.whitelistDivisions
               ? data.data.whitelistDivisions.map((value) => ({
                    label: value.divisionNameTh,
                    value: value.divisionId,
                 }))
               : [],
            blacklistDivisions: data.data.blacklistDivisions
               ? data.data.blacklistDivisions.map((value) => ({
                    label: value.divisionNameTh,
                    value: value.divisionId,
                 }))
               : [],
            whitelistEmployees: data.data.whitelistEmployees
               ? data.data.whitelistEmployees.map((value) => ({
                    label: `${value.employeeOrgId} : ${value.employeeNameTh}`,
                    value: value.employeeOrgId,
                 }))
               : [],
            blacklistEmployees: data.data.blacklistEmployees
               ? data.data.blacklistEmployees.map((value) => ({
                    label: `${value.employeeOrgId} : ${value.employeeNameTh}`,
                    value: value.employeeOrgId,
                 }))
               : [],
         });
      } else {
         setShowAdvance(false);
      }
   }, [data]);
   useEffect(() => {
      register({ name: 'startDate' });
      register({ name: 'endDate' });
      register({ name: 'location' });
      register({ name: 'isCanJoinOneMoreTime' });
      register({ name: 'isUseLocation' });
   }, [register]);
   const handleIsUseLocation = (e) => {
      setValue('isUseLocation', e.target.checked);
   };
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });
   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });
   const handleLocatione = (e) => {
      if (isObject(e) || e === null) setValue('location', e);
      else setValue('location', null);
   };
   const handleClosePopup = () => {
      setPopup(false);
   };
   const handleIsCanJoinOneMoreTime = (e) => {
      setValue('isCanJoinOneMoreTime', e.target.checked);
   };
   const handleChangeRadio = (e) => {
      const { name, value } = e.target;
      setSelectRadio((prevState) => ({ ...prevState, [name]: value }));
   };
   const handleDelete = (name, value) => (e) => {
      let arrayObj = dataModel[name];
      let removeIndex = arrayObj
         .map((item) => {
            return item.value;
         })
         .indexOf(value);
      if (removeIndex !== -1) {
         arrayObj.splice(removeIndex, 1);
         setDataModel((prevState) => ({ ...prevState, [name]: arrayObj }));
      }
   };
   const handleAdd = (name) => (e) => {
      let arrayObj = dataModel[name];
      if (
         name === 'affordableOrgEmployee' &&
         dataModel.affordableOrgEmployee.length === 5
      ) {
         return false;
      } else if (name === 'orgOwner' && dataModel.orgOwner.length === 1) {
         return false;
      } else {
         if (e) {
            let data = { label: e.label, value: e.value };
            arrayObj.push(data);
            setDataModel((prevState) => ({ ...prevState, [name]: arrayObj }));
         }
      }
   };
   const onSubmit = (e) => {
      if (dataModel.orgOwner.length === 0) return false;
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         if (e.isCanJoinOneMoreTime) {
            setPopup(true);
         } else {
            postData(values);
         }
      }
   };
   const popupPostData = () => {
      setPopup(false);
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values);
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      const result = {
         activityId: data.activityId,
         activityNameTh: values.activityNameTh
            ? values.activityNameTh.trim()
            : '-',
         activityNameEn: values.activityNameEn
            ? values.activityNameEn.trim()
            : '-',
         isCanJoinOneMoreTime: values.isCanJoinOneMoreTime ? true : false,
         orgOwnerId:
            dataModel.orgOwner.length !== 0
               ? dataModel.orgOwner[0].value
               : data.activityOwnerOrgEmployeeId,
         affordableOrgEmployeeId:
            dataModel.affordableOrgEmployee.length !== 0
               ? dataModel.affordableOrgEmployee.map(({ value }) => value)
               : [],
         isUseLocation: values.isUseLocation,
         venueTh: values.location
            ? values.location.name
               ? values.location.name
               : data.venueTh
               ? data.venueTh
               : null
            : null,
         venueEn: values.location
            ? values.location.name
               ? values.location.name
               : data.venueEn
               ? data.venueEn
               : null
            : null,
         latitude: values.location
            ? values.location.geometry
               ? values.location.geometry.location.lat
               : data.latitude
               ? data.latitude
               : null
            : null,
         longtitude: values.location
            ? values.location.geometry
               ? values.location.geometry.location.lng
               : data.longtitude
               ? data.longtitude
               : null
            : null,
         // activityPoint: +reverseFormatNumber(values.activityPoint, 'en'),
         activityPoint: null,
         startDate: format(new Date(values.startDate), 'dd/MM/yyyy HH:mm:ss'),
         endDate: format(new Date(values.endDate), 'dd/MM/yyyy HH:mm:ss'),
         gPointPerPerson: values.gPointPerPerson
            ? +reverseFormatNumber(values.gPointPerPerson, 'en')
            : data.gPointPerPerson,
         sPointPerPerson: values.sPointPerPerson
            ? +reverseFormatNumber(values.sPointPerPerson, 'en')
            : data.sPointPerPerson,
         bPointPerPerson: values.bPointPerPerson
            ? +reverseFormatNumber(values.bPointPerPerson, 'en')
            : data.bPointPerPerson,
         WhitelistEmployeeId:
            dataModel.whitelistEmployees.length !== 0 &&
            selectRadio.whiteList === 'a'
               ? dataModel.whitelistEmployees.map(({ value }) => value)
               : [],
         BlacklistEmployeeId:
            dataModel.blacklistEmployees.length !== 0 &&
            selectRadio.blackList === 'a'
               ? dataModel.blacklistEmployees.map(({ value }) => value)
               : [],
         whitelistDivisionId:
            dataModel.whitelistDivisions.length !== 0 &&
            selectRadio.whiteList === 'b'
               ? dataModel.whitelistDivisions.map(({ value }) => value)
               : [],
         blacklistDivisionId:
            dataModel.blacklistDivisions.length !== 0 &&
            selectRadio.blackList === 'b'
               ? dataModel.blacklistDivisions.map(({ value }) => value)
               : [],
      };
      Axios.post('/GSB/dashboard/activity/EditActivity', result)
         .then((resp) => {
            enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Dialog
            open={popup}
            aria-labelledby={'alert-dialog-title'}
            aria-describedby={'alert-dialog-description'}
         >
            <DialogTitle id={'alert-dialog-title'}>
               กิจกรรมนี้สามารถเข้าร่วมได้มากกว่า 1 ครั้ง
            </DialogTitle>
            <DialogActions>
               <Button onClick={handleClosePopup}>ยกเลิก</Button>
               <Button onClick={popupPostData} color={'primary'} autoFocus>
                  ยืนยัน
               </Button>
            </DialogActions>
         </Dialog>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>แก้ไขกิจกรรม</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box fontWeight={700}>
                  คะแนนสำหรับจัดกิจกรรมคงเหลือ&nbsp;&nbsp;
                  <Controller
                     as={
                        <Input
                           textAlign={'right'}
                           width={'5rem'}
                           alert={errors.activityPoint}
                           disabled
                        />
                     }
                     // rules={{ required: true }}
                     onChange={([e]) => {
                        return new Intl.NumberFormat().format(
                           e.target.value.replace(/[^0-9]/g, ''),
                        );
                     }}
                     name={'activityPoint'}
                     control={control}
                  />
                  &nbsp;&nbsp;คะแนน
               </Box>
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={2}>
                     <Grid item xs={12}>
                        <TitleLabel>รหัสกิจกรรม</TitleLabel>
                        <Input
                           name={'activityCode'}
                           placeholder={'รหัสกิจกรรม'}
                           ref={register({ required: true })}
                           width={'50%'}
                           disabled
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>ชื่อกิจกรรม</TitleLabel>
                        <Input
                           name={'activityNameTh'}
                           placeholder={'ชื่อกิจกรรมภาษาไทย'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>&nbsp;</TitleLabel>
                        <Input
                           name={'activityNameEn'}
                           placeholder={'ชื่อกิจกรรมภาษาอังกฤษ'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เจ้าของกิจกรรม
                           {dataModel.orgOwner.length === 0 && (
                              <AlertLabel>กรุณาเลือกเจ้าของกิจกรรม</AlertLabel>
                           )}
                        </TitleLabel>
                        {dataModel.orgOwner.length !== 0 ? (
                           dataModel.orgOwner.map(({ label, value }) => (
                              <div style={{ padding: '0.25rem' }}>
                                 <Chip
                                    label={label}
                                    key={value}
                                    onDelete={handleDelete('orgOwner', value)}
                                 />
                              </div>
                           ))
                        ) : (
                           <SearchEmployee onChange={handleAdd('orgOwner')} />
                        )}
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>หลักเกณฑ์</TitleLabel>
                        <Input name={'rule'} ref={register()} disabled />
                        <FormControlLabel
                           control={
                              <Checkbox
                                 name={'canJoin'}
                                 color={'primary'}
                                 size={'small'}
                                 checked={selectCheckbox}
                                 onChange={handleIsCanJoinOneMoreTime}
                              />
                           }
                           style={{ color: 'red' }}
                           label={'สามารถเข้าร่วมกิจกรรมได้มากกว่า 1 ครั้ง'}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           พนักงานที่สามารถให้คะแนน (สูงสุด 5 คน)
                        </TitleLabel>
                        <SearchEmployee
                           onChange={handleAdd('affordableOrgEmployee')}
                        />
                        <Box
                           display={'flex'}
                           flexDirection={'row'}
                           width={'100%'}
                           style={{ flexWrap: 'wrap' }}
                        >
                           {dataModel.affordableOrgEmployee &&
                              dataModel.affordableOrgEmployee.map(
                                 ({ label, value }) => (
                                    <div style={{ padding: '0.25rem' }}>
                                       <Chip
                                          label={label}
                                          key={value}
                                          onDelete={handleDelete(
                                             'affordableOrgEmployee',
                                             value,
                                          )}
                                       />
                                    </div>
                                 ),
                              )}
                        </Box>
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>สถานที่จัดกิจกรรม</TitleLabel>
                        <FormControlLabel
                           control={
                              <Checkbox
                                 name={'isUseLocation'}
                                 color={'primary'}
                                 size={'small'}
                                 checked={selectLocationCheckbox}
                                 onChange={handleIsUseLocation}
                              />
                           }
                           label={'ระบุสถานที่จัดกิจกรรม'}
                        />
                        <GoogleAddressLookup
                           apiKey={'AIzaSyBao0KGNsTpwLUcPF_0LmklXubqMRSEUME'}
                           onChange={handleLocatione}
                           value={selectLocation}
                           disabled={!getValues('isUseLocation')}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ระยะเวลาที่จัดกิจกรรม
                           {(errors.startDate || errors.endDate) && (
                              <AlertLabel>
                                 กรุณาเลือกระยะเวลาที่จัดกิจกรรม
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectStartDate}
                              onDateChange={handleStartDateChange}
                              // locale={th}
                              // format="dd MMM yyyy"
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className={'input'}
                                       {...timeStartInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>&nbsp;</TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectEndDate}
                              onDateChange={handleEndDateChange('auto')}
                              // locale={th}
                              // format="dd MMM yyyy"
                              minimumDate={
                                 getValues('startDate')
                                    ? getValues('startDate')
                                    : new Date()
                              }
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className={'input'}
                                       {...timeEndInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
               <Box width={'100%'}>
                  <Box>
                     <Typography variant={'h5'}>กำหนดจำนวน</Typography>
                  </Box>
                  <Box>
                     <TitleLabel>จำนวนคะแนนที่ให้ต่อคน</TitleLabel>
                     <Box display='flex' gridGap={'8px'}>
                        <Controller
                           as={
                              <TextFieldCustom
                                 textAlign={'right'}
                                 // width={"33.33%"}
                                 placeholder={'B'}
                                 variant={'outlined'}
                                 size={'small'}
                                 InputProps={{
                                    startAdornment: (
                                       <InputAdornment position={'start'}>
                                          for SOCIETY
                                       </InputAdornment>
                                    ),
                                 }}
                                 disabled
                              />
                           }
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name={'bPointPerPerson'}
                           control={control}
                        />
                        <Controller
                           as={
                              <TextFieldCustom
                                 textAlign={'right'}
                                 // width={"33.33%"}
                                 placeholder={'G'}
                                 variant={'outlined'}
                                 size={'small'}
                                 InputProps={{
                                    startAdornment: (
                                       <InputAdornment position={'start'}>
                                          with GOVERNANCE
                                       </InputAdornment>
                                    ),
                                 }}
                                 disabled
                              />
                           }
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name={'gPointPerPerson'}
                           control={control}
                        />
                        <Controller
                           as={
                              <TextFieldCustom
                                 textAlign={'right'}
                                 // width={"33.33%"}
                                 placeholder={'S'}
                                 variant={'outlined'}
                                 size={'small'}
                                 InputProps={{
                                    startAdornment: (
                                       <InputAdornment position={'start'}>
                                          through DIGITALIZATION
                                       </InputAdornment>
                                    ),
                                 }}
                                 disabled
                              />
                           }
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name={'sPointPerPerson'}
                           control={control}
                        />
                     </Box>
                  </Box>
               </Box>
               <Box my={1} width={'100%'}>
                  <Box>
                     <Button
                        variant={'contained'}
                        size={'small'}
                        onClick={() => setShowAdvance(!showAdvance)}
                     >
                        {showAdvance ? 'ปิด' : 'ตัวเลือกเพิ่มเติม'}
                     </Button>
                  </Box>

                  <Box width={'100%'}>
                     {showAdvance && editAdvance && (
                        <React.Fragment>
                           <Box
                              display={'flex'}
                              justifyContent={'center'}
                              alignContent={'center'}
                              alignItems={'center'}
                           >
                              <Box width={'10%'}>
                                 <Radio
                                    checked={selectRadio.whiteList === 'a'}
                                    onChange={handleChangeRadio}
                                    value={'a'}
                                    name={'whiteList'}
                                    inputProps={{ 'aria-label': 'A' }}
                                 />
                              </Box>
                              <Box width={'90%'}>
                                 <Box width={'100%'}>
                                    <TitleLabel>
                                       white list ตามรหัสพนักงาน
                                    </TitleLabel>
                                    <Box
                                       display={'flex'}
                                       width={'100%'}
                                       style={{ flexWrap: 'wrap' }}
                                    >
                                       {dataModel.whitelistEmployees &&
                                          dataModel.whitelistEmployees.map(
                                             ({ label, value }) => (
                                                <div
                                                   style={{
                                                      padding: '0.25rem',
                                                   }}
                                                >
                                                   <Chip
                                                      label={label}
                                                      key={value}
                                                      onDelete={handleDelete(
                                                         'whitelistEmployees',
                                                         value,
                                                      )}
                                                   />
                                                </div>
                                             ),
                                          )}
                                    </Box>
                                    <SearchEmployee
                                       isDisabled={
                                          selectRadio.whiteList === 'b' && true
                                       }
                                       onChange={handleAdd(
                                          'whitelistEmployees',
                                       )}
                                    />
                                 </Box>
                              </Box>
                           </Box>
                           <Box
                              display={'flex'}
                              justifyContent={'center'}
                              alignContent={'center'}
                              alignItems={'center'}
                           >
                              <Box width={'10%'}>
                                 <Radio
                                    checked={selectRadio.whiteList === 'b'}
                                    onChange={handleChangeRadio}
                                    value={'b'}
                                    name={'whiteList'}
                                    inputProps={{ 'aria-label': 'b' }}
                                 />
                              </Box>
                              <Box width={'90%'}>
                                 <Box width={'100%'}>
                                    <TitleLabel>
                                       white list ตามสังกัด
                                    </TitleLabel>
                                    <Box
                                       display={'flex'}
                                       width={'100%'}
                                       style={{ flexWrap: 'wrap' }}
                                    >
                                       {dataModel.whitelistDivisions &&
                                          dataModel.whitelistDivisions.map(
                                             ({ label, value }) => (
                                                <div
                                                   style={{
                                                      padding: '0.25rem',
                                                   }}
                                                >
                                                   <Chip
                                                      label={label}
                                                      key={value}
                                                      onDelete={handleDelete(
                                                         'whitelistDivisions',
                                                         value,
                                                      )}
                                                   />
                                                </div>
                                             ),
                                          )}
                                    </Box>
                                    <SearchDivision
                                       onChange={handleAdd(
                                          'whitelistDivisions',
                                       )}
                                       isDisabled={
                                          selectRadio.whiteList === 'a' && true
                                       }
                                    />
                                 </Box>
                              </Box>
                           </Box>
                           <Divider style={{ margin: '0.5rem 0' }} />
                           <Box
                              display={'flex'}
                              justifyContent={'center'}
                              alignContent={'center'}
                              alignItems={'center'}
                           >
                              <Box width={'10%'}>
                                 <Radio
                                    checked={selectRadio.blackList === 'a'}
                                    onChange={handleChangeRadio}
                                    value={'a'}
                                    name={'blackList'}
                                    inputProps={{ 'aria-label': 'b' }}
                                 />
                              </Box>
                              <Box width={'90%'}>
                                 <Box width={'100%'}>
                                    <TitleLabel>
                                       Black list ตามรหัสพนักงาน
                                    </TitleLabel>
                                    <Box
                                       display={'flex'}
                                       width={'100%'}
                                       style={{ flexWrap: 'wrap' }}
                                    >
                                       {dataModel.blacklistEmployees &&
                                          dataModel.blacklistEmployees.map(
                                             ({ label, value }) => (
                                                <div
                                                   style={{
                                                      padding: '0.25rem',
                                                   }}
                                                >
                                                   <Chip
                                                      label={label}
                                                      key={value}
                                                      onDelete={handleDelete(
                                                         'blacklistEmployees',
                                                         value,
                                                      )}
                                                   />
                                                </div>
                                             ),
                                          )}
                                    </Box>
                                    <SearchEmployee
                                       onChange={handleAdd(
                                          'blacklistEmployees',
                                       )}
                                       isDisabled={
                                          selectRadio.blackList === 'b' && true
                                       }
                                    />
                                 </Box>
                              </Box>
                           </Box>
                           <Box
                              display={'flex'}
                              justifyContent={'center'}
                              alignContent={'center'}
                              alignItems={'center'}
                           >
                              <Box width={'10%'}>
                                 <Radio
                                    checked={selectRadio.blackList === 'b'}
                                    onChange={handleChangeRadio}
                                    value={'b'}
                                    name={'blackList'}
                                    inputProps={{ 'aria-label': 'b' }}
                                 />
                              </Box>
                              <Box width={'90%'}>
                                 <Box width={'100%'}>
                                    <TitleLabel>
                                       Black list ตามสังกัด
                                    </TitleLabel>
                                    <Box
                                       display={'flex'}
                                       width={'100%'}
                                       style={{ flexWrap: 'wrap' }}
                                    >
                                       {dataModel.blacklistDivisions &&
                                          dataModel.blacklistDivisions.map(
                                             ({ label, value }) => (
                                                <div
                                                   style={{
                                                      padding: '0.25rem',
                                                   }}
                                                >
                                                   <Chip
                                                      label={label}
                                                      key={value}
                                                      onDelete={handleDelete(
                                                         'blacklistDivisions',
                                                         value,
                                                      )}
                                                   />
                                                </div>
                                             ),
                                          )}
                                    </Box>
                                    <SearchDivision
                                       onChange={handleAdd(
                                          'blacklistDivisions',
                                       )}
                                       isDisabled={
                                          selectRadio.blackList === 'a' && true
                                       }
                                    />
                                 </Box>
                              </Box>
                           </Box>
                        </React.Fragment>
                     )}
                  </Box>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ยืนยัน
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
};

export default Edit;
